import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { editSummary } from "../../Store/Actions";
import Buttons from "./Buttons";
export default function EditSummary({ setOpen = () => {} }) {
  const dispatch = useDispatch();
  const { resume } = useSelector(({ skillsReducer }) => {
    return {
      resume: skillsReducer?.resume,
    };
  });
  const [summary, setSummary] = useState((prev) => {
    const summary = resume?.general?.SUMMARY
      ? resume?.general?.SUMMARY?.join("\n")
      : "";
    return summary;
  });
  const onChangeHandler = (e) => {
    setSummary(e.target?.value);
  };
  const saveHandler = (e) => {
    e.preventDefault();
    const newSummary = summary?.split("\n");
    const newArr = newSummary?.reduce((acc, item) => {
      if (item !== "") {
        return [...acc, item];
      } else {
        return [...acc];
      }
    }, []);
    dispatch(editSummary(newArr));
    setOpen(false);
  };
  const style = {
    display: "flex",
    gap: "24px",
    flexDirection: "column",
  };
  const textareaStyle = {
    width: "503px",
    height: "118px",
    padding: "19px 16px",
    boxSizing: "border-box",
    border: "1px solid #DCDCDC",
    borderRadius: "8px",
    resize: "none",
    fontFamily: "'Montserrat'",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "20px",
    color: "#1D2C34",
  };
  return (
    <form style={{ ...style }} onSubmit={saveHandler}>
      <textarea
        placeholder="Edit Summary"
        value={summary}
        onChange={onChangeHandler}
        style={{ ...textareaStyle }}
      />
      <Buttons
        saveHandler={() => {}}
        cancelationHandler={() => {
          setOpen(false);
        }}
      />
    </form>
  );
}
